// Microsoft Clarity loader and identity helpers.
// customId is the Cognito user sub (no PII) so users are recognizable across
// sessions in the Clarity dashboard without exposing email/name to Microsoft.
//
// Clarity must never be loaded before the user has given cookie consent, so
// loadClarityScript() is the only place the tracking script is injected.

const CLARITY_PROJECT_ID = "xy3xog89s6";

export function loadClarityScript() {
  if (typeof window.clarity !== "function") {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = "https://www.clarity.ms/tag/" + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
  }

  // Clarity loads in consentless mode by default and won't persist
  // tracking cookies until explicitly told consent was given.
  window.clarity("consent");
}

export function identifyClarityUser(user) {
  if (typeof window.clarity !== "function") return;

  const customId = user?.userId || user?.username;
  if (!customId) return;

  window.clarity("identify", customId);
}

export function setClarityCompanyTag(companyName) {
  if (typeof window.clarity !== "function") return;
  if (!companyName) return;

  window.clarity("set", "companyName", companyName);
}
